import { useId } from 'react'

import type { ReviewModalLabels } from './types'

import { fillLabel } from '../fill-label'
import { StarRatingInput } from '../star-rating'

interface Props {
  score: number
  message: string
  onScore: (score: number) => void
  onMessage: (message: string) => void
  labels: ReviewModalLabels
}

export const Experience = ({ score, message, onScore, onMessage, labels }: Props) => {
  const id = useId()
  return (
    <div>
      <p className="text-[16px] font-semibold text-navy">{labels.yourRating}</p>
      <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-2">
        <StarRatingInput
          value={score}
          onChange={onScore}
          label={labels.yourRating}
          optionLabel={(stars) => fillLabel(labels.ratingOutOf5, { score: stars })}
        />
        <span className="text-[16px] text-navy-80" aria-live="polite">
          {score > 0 ? fillLabel(labels.ratingOutOf5, { score }) : labels.chooseRating}
        </span>
      </div>
      <label htmlFor={id} className="mt-7 block text-[16px] font-semibold text-navy">
        {labels.messageLabel}
      </label>
      <p id={`${id}-help`} className="mt-2 text-[16px] leading-relaxed text-navy-80">
        {labels.messagePlaceholder}
      </p>
      <textarea
        id={id}
        aria-describedby={`${id}-help`}
        value={message}
        onChange={(event) => onMessage(event.target.value)}
        rows={4}
        maxLength={2000}
        className="mt-3 block min-h-32 w-full resize-y rounded-xl border border-navy-20 p-4 text-[16px] leading-relaxed text-navy caret-lapis focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lapis"
        data-tracking="ignore"
      />
      <p className="mt-4 text-[14px] leading-relaxed text-navy-80">{labels.reviewHelp}</p>
    </div>
  )
}
